import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { filterAnalyticsParameters } from 'apps/analytics/utils/requestParameters';
import PageStatistic from 'apps/analytics/components/PageStatistic';
import { queryToString } from 'utils/url';

const PARAMETER_TO_PAGE_STATISTIC_FIELD = {
  fromSearchTerm: 'FROM_SEARCH_TERM',
};

export default class PageStatisticsForRequestParams extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      createLocation: PropTypes.func.isRequired,
    }),
  };

  componentDidMount() {
    this.updateLocationIfRequired();
  }

  componentDidUpdate() {
    this.updateLocationIfRequired();
  }

  updateLocationIfRequired() {
    const { location } = this.props;

    const filteredSearch = filterAnalyticsParameters(location.query);
    if (this.locationHasAnyAnalyticParameters(filteredSearch)) {
      this.updateLocation(filteredSearch.query);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  locationHasAnyAnalyticParameters(filteredSearch = {}) {
    return filteredSearch.analyticParameters && Object.keys(filteredSearch.analyticParameters).length > 0;
  }

  updateLocation(newQuery) {
    const { router } = this.props;
    const newLocation = this.createNewLocationWithState(newQuery);
    router.replace(newLocation);
  }

  createNewLocationWithState(newQuery) {
    const { location, router } = this.props;

    const newQueryString = queryToString(newQuery);
    const newHref = `${location.pathname}${newQueryString ? `?${newQueryString}` : ''}`;
    const newLocation = router.createLocation(newHref);
    const currentState = location.state;

    return {
      ...newLocation,
      state: {
        ...currentState,
        originalLocation: `${location.pathname}${location.search}`,
      },
    };
  }

  // eslint-disable-next-line class-methods-use-this
  trackAnalyticsParameters(analyticParameters) {
    return analyticParameters && Object.keys(analyticParameters)
      .filter(parameter => PARAMETER_TO_PAGE_STATISTIC_FIELD[parameter])
      .map((parameter) => {
        const field = PARAMETER_TO_PAGE_STATISTIC_FIELD[parameter];
        const value = analyticParameters[parameter];
        return (
          <PageStatistic
            field={field}
            value={value}
            key={`analytic_param_${field}`}
          />
        );
      });
  }

  render() {
    const { location } = this.props;
    const filteredSearch = filterAnalyticsParameters(location.query);

    if (!this.locationHasAnyAnalyticParameters(filteredSearch)) {
      return null;
    }

    return this.trackAnalyticsParameters(filteredSearch.analyticParameters);
  }
}
